export const keySelectorCombiner = ({ inputSelectors = [] } = {}) => {
  // Nested re-reselect selectors carry their own keySelector, which already
  // incorporates the props relevant to them. Plain prop selectors (e.g.
  // storeIdPropSelector) have no keySelector, so fall back to calling them
  // directly - otherwise their value never enters the cache key at all and
  // every selector built on top of them collapses onto a single cache slot.
  const keySelectors = inputSelectors.map(entry => entry?.keySelector ?? entry);

  // The actual keySelector
  return (...args) => {
    return keySelectors
      .filter(keySelector => typeof keySelector === 'function')
      .map(keySelector => keySelector(...args))
      .filter(value => {
        const valueType = typeof value;
        return valueType === 'string' || valueType === 'number';
      })
      .join(':');
  };
};
